import { GoogleEvent } from '../components/form/master-form'

export const trackFormEvent = (formCode, category, action, value, label) => {
  const trackingObj = {
    formCode,
    event: category,
    action,
    value,
    label,
  }
  // console.log('[tracking] Tracking data', trackingObj)
  if (window && window.dataLayer) {
    window.dataLayer.push(trackingObj)

    /**
     * Use special event tracking for Google Ads to pick up
     * This is due to changing how Google Ads tracks from conversions - previously via GA4 but now Google Ads directly, using GTM
     */
    if (action === GoogleEvent.Action.SubmitSuccess) {
      window.dataLayer.push({ event: 'lead_success_legacy' })
    }
  }
}
